export default {
  essBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
  commonBaseUrl: process.env.REACT_APP_COMMON_API_BASE_URL || '',
};
